import React from 'react'

const Coffee: React.FC = () => {
    return (
        <svg
            width="58"
            height="52"
            viewBox="0 0 58 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.88525 41.7253C13.3144 40.5557 19.1912 37.8473 23.9976 32.7181C27.7615 28.8062 30.8084 24.4281 33.9894 20.7321C37.1276 16.977 40.5222 14.0486 43.7429 12.3015C45.4038 11.3674 46.9718 10.7552 48.3674 10.3794C48.1594 10.1167 48.0179 9.87467 47.7798 9.61789C44.4441 5.85477 39.4887 4.02974 34.7216 3.95572C29.948 3.84923 25.3006 5.3373 20.9489 7.37443C15.7991 9.80478 10.8282 13.1445 7.75233 18.1693C4.22591 23.9238 3.55686 31.6462 6.03651 38.2093C6.52658 39.4286 7.16715 40.6183 7.88525 41.7253Z"
                fill="#E0E0E0"
            />
            <path
                d="M25.9377 47.8229C32.0236 46.018 38.2298 44.1895 43.425 40.4007C48.6202 36.612 52.9985 30.42 52.9417 23.6163C53.1948 21.4073 52.6503 16.8926 50.4385 13.2794C49.032 13.7586 47.4768 14.4357 45.7812 15.5116C42.8334 17.3737 39.7096 20.2487 36.752 23.9683C33.7214 27.6347 30.7239 32.1043 26.7748 36.1876C22.8686 40.33 18.0664 43.0968 13.4728 44.5405C12.4449 44.8777 11.4278 45.1116 10.4344 45.3071C11.73 46.8064 13.2819 48.0192 15.0991 48.6737C18.6241 49.9031 22.4259 48.8851 25.9377 47.8229Z"
                fill="#E0E0E0"
            />
        </svg>
    )
}

export default Coffee
